import React from "react";
import "./Table.scss";
import PanelApprovedProperties from "./TableContents/PanelApprovedProperties";
import PropertyListTable from "./TableContents/PropertyListTable";
import ListAgentTable from "./TableContents/ListAgentTable";
import Pagination from "components/Pagination/Pagination";
import ContactRequest from "./TableContents/ContactRequestTable";
import RentalRequest from "./TableContents/RentalRequestTable";
import SubmitedProperty from "./TableContents/SubmitedPropertyTable";
import { Addresses } from "utils/Addresses";

interface Props {
  TableHeader: Array<any>;
  TableContent: Array<Array<any>>;
  TableContentName: string;
  HeaderMinWidth?: Array<any>;
  currentPage?: number;
  totalPage?: number;
  setPageNumber?: React.Dispatch<React.SetStateAction<number>>;
  changeData?:()=>void
}

const Table: React.FC<Props> = ({
  TableHeader,
  TableContent,
  TableContentName,
  HeaderMinWidth,
  currentPage,
  totalPage,
  setPageNumber,
  changeData = ()=>{},
}) => {
  return (
    <>
      <div id="tableHeader" className="table-main-parent">
        <div style={{ overflowX: "auto", overflowY: "hidden", width: "100%" }}>
          <div className="table-header-parent">
            {TableHeader.map((item, key) => (
              <p
                style={{
                  minWidth:
                    HeaderMinWidth !== undefined ? HeaderMinWidth[key] : "",
                }}
                key={key}
              >
                {item}
              </p>
            ))}
          </div>          
          {TableContent.length > 0 ? (
            TableContentName === "panelApprovedProperties" ? (
              <PanelApprovedProperties
                TableContent={TableContent}
                HeaderMinWidth={HeaderMinWidth}
              />
            ) : TableContentName === "propertyList" ? (
              <PropertyListTable
                TableContent={TableContent}
                HeaderMinWidth={HeaderMinWidth}
              />
            ) : TableContentName === "listAgent" ? (
              <ListAgentTable
                TableContent={TableContent}
                HeaderMinWidth={HeaderMinWidth}
              />
            ) : TableContentName === "contactRequest" ? (
              <ContactRequest
                TableContent={TableContent}
                HeaderMinWidth={HeaderMinWidth}
                changeData={changeData}
              />
            ) : TableContentName === "rentalRequest" ? (
              <RentalRequest
                TableContent={TableContent}
                HeaderMinWidth={HeaderMinWidth}
                changeData={changeData}
              />
            ) : TableContentName === "submitedProperty" ? (
              <SubmitedProperty
                TableContent={TableContent}
                HeaderMinWidth={HeaderMinWidth}
                changeData={changeData}
              />
            ) : (
              <></>
            )
          ) : (
            <div className="empty-table-parent">
              <img src={Addresses.images.PAGE_404} />
              <p>No Data Found</p>
            </div>
          )}
        </div>
        {currentPage !== undefined &&
        totalPage !== undefined &&
        setPageNumber !== undefined ? (
          <Pagination
            currentPage={currentPage}
            totalPage={totalPage}
            setPageNumber={setPageNumber}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default Table;
